<template>
  <div class="landing-root">
    <LandingPageLandingHeader/>
    <LandingPageRanking/>
    <LandingPageLandingFooter/>
    <LandingPageLandingLoader/>
  </div>
</template>

<script setup>
useHead({
  title: 'Oxbull | Hall of Fame',
  meta: [
    { name: 'title', content: "Oxbull | Hall of Fame" },
    { name: 'description', content: "Discover our Hall of Fame, showcasing blockchain projects with high ROI. Learn about success stories and pioneering initiatives in the crypto space, offering high-yield investment opportunities. Redefine your investment journey with us." }
  ],
  htmlAttrs: { lang: "en" }
})
</script>

<style scoped lang="scss">

$_primary-color: #3f4759;
$_secondary-color: #27e9af;
$_tertiary-color: #ececec;

.landing-root {
  font-family: "Rogan";
  font-weight: 400;
  color: $_primary-color;
  font-synthesis: none;
  overflow: hidden;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}

.secondary-text {
  color: $_secondary-color;
}



</style>